<h1 mat-dialog-title>{{this.gfar.id ? "Edit" : "New"}} GFXR</h1>
<div mat-dialog-content>

    <form class="example-form">

        <mat-form-field class="example-full-width" style="width: 100%;">
            <mat-label>Currency *</mat-label>
            <input matInput [(ngModel)]='gfar.cr_name' [ngModelOptions]="{standalone: true}">
        </mat-form-field>

        <br>

        <mat-form-field class="example-full-width" style="width: 100%;">
            <mat-label>GFXR rate *</mat-label>
            <input matInput #gfar_rate [(ngModel)]='gfar.gf_rate' [ngModelOptions]="{standalone: true}">
        </mat-form-field>

        <tr>
            <td>
                <mat-form-field>
                    <mat-label>Effective date *</mat-label>
                    <input matInput [matDatepicker]="picker1" [min]="minDate"
                        [(ngModel)]="gfar.effective_date" [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle matSuffix [for]="picker1" />
                    <mat-datepicker #picker1 />
                </mat-form-field>
            </td>
            <td>
                <mat-form-field>
                    <mat-label>Valid to</mat-label>
                    <input matInput [matDatepicker]="picker2" [min]="minDate"
                        [(ngModel)]="gfar.invalid_date" [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle matSuffix [for]="picker2" />
                    <mat-datepicker #picker2 />
                </mat-form-field>
            </td>
        </tr>

    </form>
</div>

<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-button (click)="onOkClick()" cdkFocusInitial>Ok</button>
</div>
